import { QBox, QStack, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { QualioDocumentAuditGroups } from '../../../../../api/model/document';
import { DocumentUsers } from '../DocumentUsers';
import {
  ManageEditorsButton,
  ManageEditorsButtonProps,
} from './ManageEditorsButton';

export type ManageEditorsProps = {
  editors: QualioDocumentAuditGroups['editor_group'];
} & ManageEditorsButtonProps;

export const ManageEditors = ({
  editors = [],
  groups,
  users,
  tags,
}: ManageEditorsProps) => {
  const { t } = useTranslation();

  return (
    <QBox data-cy={`document-overview-editors`}>
      <QStack isInline justifyContent="space-between" alignItems="center">
        <QText fontWeight="semibold" fontSize="md">
          {t('labels.editors')}
        </QText>
        <ManageEditorsButton groups={groups} users={users} tags={tags} />
      </QStack>
      <DocumentUsers userType="editor" users={editors} />
    </QBox>
  );
};
